import { render, staticRenderFns } from "./IrrigatorEventsPDF.vue?vue&type=template&id=51d35f96&"
import script from "./IrrigatorEventsPDF.vue?vue&type=script&lang=js&"
export * from "./IrrigatorEventsPDF.vue?vue&type=script&lang=js&"
import style0 from "./IrrigatorEventsPDF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCol,VIcon,VImg})
